import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Forum"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.25 5.25H7.5C6.25787 5.25124 5.25124 6.25787 5.25 7.5V15.75C5.25124 16.9921 6.25787 17.9988 7.5 18H12V16.5H7.5C7.08579 16.5 6.75 16.1642 6.75 15.75V7.5C6.75041 7.08596 7.08596 6.75041 7.5 6.75H20.25C20.6642 6.75 21 7.08579 21 7.5V15.75C21 16.1642 20.6642 16.5 20.25 16.5H16.35L12.75 21.6405L13.9792 22.5L17.1307 18H20.25C21.4921 17.9988 22.4988 16.9921 22.5 15.75V7.5C22.4988 6.25787 21.4921 5.25124 20.25 5.25ZM2.25 12.75H0.75V3C0.75124 1.75787 1.75787 0.75124 3 0.75H12.75V2.25H3C2.58596 2.25041 2.25041 2.58596 2.25 3V12.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Forum.vue"]]);
